// Global
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import React, { ReactElement, useEffect } from 'react';
import { ProductAndArticleComponent } from 'lib/templates/Feature.Dart.model';
import { ItemEx } from 'lib/templates/_.Sitecore.Override';

export type ProductInformation = ItemEx &
  ProductAndArticleComponent.ProductInformation.ProductInformation;

const BazaarvoiceScript = (): ReactElement => {
  const context = useSitecoreContext();
  const { productInformation } = context?.sitecoreContext?.route?.fields || {};
  const prodInfo = productInformation as ProductInformation;
  const clientName = (context?.sitecoreContext?.bazaarVoice as { clientName?: string })?.clientName;
  const environment = (context?.sitecoreContext?.bazaarVoice as { environment?: string })
    ?.environment;
  const locale = (context?.sitecoreContext?.bazaarVoice as { locale?: string })?.locale;
  const siteID = (context?.sitecoreContext?.bazaarVoice as { siteID?: string })?.siteID;

  useEffect(() => {
    const scriptSrc = `https://apps.bazaarvoice.com/deployments/${clientName}/${siteID}/${environment}/${locale}/bv.js`;

    // Check if script already exists to avoid duplicates
    const existingScript = document.head.querySelector(`script[src="${scriptSrc}"]`);

    let script: HTMLScriptElement;

    if (!existingScript) {
      script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      script.setAttribute('data-bazaarvoice-component', 'true'); // Mark our script

      document.head.appendChild(script);
    } else {
      script = existingScript as HTMLScriptElement;
    }

    const element = document.getElementById('bv-reviewdisplay');
    if (element) {
      const productId = `${(prodInfo?.fields?.oldPageId?.value || prodInfo?.id)
        ?.replace(/-/g, '')
        .toUpperCase()}`;
      element.setAttribute('data-bv-product-id', productId);
    }

    // Cleanup function - only remove OUR specific script
    return () => {
      // Only remove the specific script we created (not existing ones)
      const ourScript = document.head.querySelector(
        `script[src="${scriptSrc}"][data-bazaarvoice-component="true"]`
      );
      if (ourScript && ourScript.parentNode) {
        ourScript.parentNode.removeChild(ourScript);
      }

      // Remove the attribute that was set
      const element = document.getElementById('bv-reviewdisplay');
      if (element) {
        element.removeAttribute('data-bv-product-id');
      }
    };
  }, [clientName, siteID, environment, locale, prodInfo?.fields?.oldPageId?.value, prodInfo?.id]);

  return <></>;
};

export default BazaarvoiceScript;
